import React from 'react';
import { Button } from '@/components/ui/button';
import { TrendingUp } from 'lucide-react';

export default function LoginPage() {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="bg-card border border-border rounded-xl p-8 md:p-12 shadow-lg">
          <div className="text-center mb-8">
            <div className="flex justify-center items-center gap-2 mb-4">
              <img src="/logo.svg" alt="Orbit" className="w-10 h-10" />
              <span className="text-2xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>Orbit</span>
            </div>
            <h1 className="text-2xl md:text-3xl font-bold mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>Welcome Back</h1>
            <p className="text-muted-foreground">Sign in to access your personalized investment plan</p>
          </div>

          <Button 
            className="w-full text-lg py-6" 
            size="lg"
            onClick={handleGoogleLogin}
            data-testid="google-login-button"
          >
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
              <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </Button>

          <p className="text-xs text-center text-muted-foreground mt-6">
            By continuing, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
}
